/// <amd-module name="TFS/Admin/Views/TeamSelector/ContextualTeamSelector" />
import React = require("react");

import { TeamSelector } from "TeamSelector";

import { Components, VssComponent, IVssComponentProperties, IVssComponentContext } from "VSS/Platform/Layout";
import { ITfsTeamService } from "TFS/Services/TfsTeamService";

/**
 * This Team selector is for tabs that supports team but doesn't require a team.
 * Team picker is shown only if a team was explicitly provided/selected.
 */
class ContextualTeamSelector extends VssComponent<IVssComponentProperties> {
    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props);
        this.context = context;
    }

    public render(): JSX.Element | null {
        const teamService = this.context.pageContext.getService<ITfsTeamService>("ITfsTeamService");
        if (!!teamService.getPageTeam(true)) {
            return <TeamSelector props={this.props} />;
        } else {
            return null;
        }
    }
}

Components.add("contextual-team-selector", ContextualTeamSelector);
